import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class RefreshProvider {
  public $: Observable<void>;

  private $subject = new Subject<void>();
  private isDirty = false;

  constructor() {
    this.$ = this.$subject.asObservable();
  }

  public refresh() {
    if (this.isDirty) {
      this.$subject.next();
    }
    this.isDirty = false;
  }

  public setDirty() {
    this.isDirty = true;
  }
}



// WEBPACK FOOTER //
// ./src/providers/refresh/refresh.ts